import { number, string, func, object } from 'prop-types';
import React, { PureComponent } from 'react';
import { Modal } from 'ps-design';
import SearchBarMP from '../SearchBarMP/SearchBarMP';
import DataCutsList from './DataCutsList';
import * as DataCutUtils from '../lib/helpers/dataCutsUtils';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';

export default class EditDataCutsModal extends PureComponent {
  static propTypes = {
    sourceMapId: number,
    surveyCode: string,
    surveyDetails: object,
    loadDataCutsPanel: func,
    jobCode: string,
    typeOfMatch: string,
    esSearchQuery: string,
    orgJobId: number
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    //  do not update the state with prop changes if changes have been made or the initial items list was populated

    if (prevState.hasChanges) {
      return prevState;
    } else {
      return {
        items: nextProps.surveyDetails.cuts.items.map(item => {
          return { ...item };
        })
      };
    }
  }

  constructor(props) {
    super(props);
    this.show = this.show.bind(this);
    this.renderFavoriteHeaderContent = this.renderFavoriteHeaderContent.bind(this);
    this.renderOtherHeaderContent = this.renderOtherHeaderContent.bind(this);
    this.renderRowContent = this.renderRowContent.bind(this);
    this.renderSearchBar = this.renderSearchBar.bind(this);
    this.addDefaultCut = this.addDefaultCut.bind(this);
    this.removeDefaultCut = this.removeDefaultCut.bind(this);
    this.searchDataCuts = this.searchDataCuts.bind(this);
    this.applyChanges = this.applyChanges.bind(this);

    let items = null;
    if (props.surveyDetails && props.surveyDetails.cuts && props.surveyDetails.cuts.items) {
      items = props.surveyDetails.cuts.items.map(item => {
        return { ...item };
      });
    }

    this.state = {
      hasChanges: false,
      items: items
    };
  }

  componentDidMount() {
    if (this.props.typeOfMatch === 'jobMatch') {
      this.props.loadDataCutsPanel(this.props.sourceMapId);
    }
  }

  show() {
    this.modal.show();
  }

  searchDataCuts(query) {
    const items = DataCutUtils.filterDataCuts(this.state.items, query);
    this.setState({
      items,
      hasChanges: true
    });
  }

  addDefaultCut(dataCut) {
    this.setState({
      hasChanges: true,
      items: this.state.items.map(item => {
        if (item.unique_identifier === dataCut.unique_identifier) {
          return {
            ...item,
            job_scope_checked: true,
            has_local_changes: true
          };
        } else return item;
      })
    });
  }

  removeDefaultCut(dataCut) {
    this.setState({
      hasChanges: true,
      items: this.state.items.map(item => {
        if (item.unique_identifier === dataCut.unique_identifier) {
          return {
            ...item,
            job_scope_checked: false,
            has_local_changes: true
          };
        } else return item;
      })
    });
  }

  applyChanges() {
    const addedCuts = this.state.items.filter(item => item.job_scope_checked === true && item.has_local_changes);
    const removedCuts = this.state.items.filter(item => item.job_scope_checked === false && item.has_local_changes);

    if (addedCuts.length === 0 && removedCuts.length === 0) return;

    this.props.surveyDetails.actions.updateDefaultCuts(
      this.props.sourceMapId,
      this.props.surveyCode,
      addedCuts ? addedCuts : [],
      removedCuts ? removedCuts : [],
      this.props.jobCode,
      this.props.esSearchQuery,
      this.props.orgJobId
    );

    this.setState({
      hasChanges: false,
      items: this.state.items.map(item => {
        return {
          ...item,
          has_local_changes: false
        };
      })
    });

    this.modal.hide();
  }

  renderFavoriteHeaderContent() {
    return <th className="edit-favorite-data-cuts-modal__header-text">Favorite Data Cuts</th>;
  }

  renderOtherHeaderContent() {
    return <th className="edit-favorite-data-cuts-modal__header-text">Other Data Cuts</th>;
  }

  renderRowContent(row, getAction) {
    return (
      <td>
        <div className="edit-favorite-data-cuts-modal__header-multi-field">
          <p className="edit-favorite-data-cuts-modal__header-survey">
            {getAction(row)}
            {row.job_scope}
          </p>
        </div>
      </td>
    );
  }

  renderSearchBar() {
    return (
      <SearchBarMP
        searchHandler={this.searchDataCuts}
        placeholder="Search for a Data Cut"
        activeQuerying={'keyup'}
        extraClass="edit-favorite-data-cuts-modal__search-bar"
      />
    );
  }

  render() {
    const { sourceMapId } = this.props;
    const { items } = this.state;

    return (
      <Modal
        id="edit-favorite-data-cuts-modal"
        className="edit-favorite-data-cuts-modal"
        displayCloseButton={true}
        ref={editFavoriteDataCutsModal => {
          this.modal = editFavoriteDataCutsModal;
        }}
      >
        <LoadingIndicator loading={this.props.surveyDetails.surveySearchDefaultCutsLoading}>
          <h2 className="edit-favorite-data-cuts-modal__header">Favorite a Data Cut</h2>
          {this.renderSearchBar()}
          <div className="edit-favorite-data-cuts-modal__body">
            <DataCutsList
              rows={items}
              renderHeaderContent={this.renderFavoriteHeaderContent}
              renderRowContent={this.renderRowContent}
              isFavorites
              extraClass="edit-favorite-data-cuts-modal__favorite-cuts-list"
              clickHandler={this.removeDefaultCut}
              itemId={sourceMapId}
            />
            <DataCutsList
              rows={items}
              renderHeaderContent={this.renderOtherHeaderContent}
              renderRowContent={this.renderRowContent}
              extraClass="edit-favorite-data-cuts-modal__available-cuts-list"
              showColumnHeaders={false}
              clickHandler={this.addDefaultCut}
              itemId={sourceMapId}
              isMatch={true}
            />
          </div>
          <div className="edit-favorite-data-cuts-modal__footer">
            <button
              className="pxl-btn pxl-btn-primary edit-favorite-data-cuts-modal__apply"
              onClick={this.applyChanges}
            >
              Apply
            </button>
          </div>
        </LoadingIndicator>
      </Modal>
    );
  }
}
